import {Component, Input, OnInit} from '@angular/core';

export interface ImageModelChooser {
  isSelected: boolean;
  name: string;
  img: string;
  id: string;
}

@Component({
  selector: 'app-image-model-item',
  templateUrl: './image-model-item.component.html',
  styleUrls: ['./image-model-item.component.scss']
})
export class ImageModelItemComponent implements OnInit {
  @Input() imageModel: ImageModelChooser;
  constructor() { }

  ngOnInit(): void {
  }

  clicked() {
    this.imageModel.isSelected = !this.imageModel.isSelected;
  }
}
